import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConsultorioCompartilhamentoService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-compartilhamento.service';
import { ConsultorioCompartilhamentoRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-compartilhamento.model';

@Injectable({ providedIn: 'root' })
/** Fachada de compartilhamento (médicos vinculados) do consultório privado. */
export class ConsultorioCompartilhamentoFeatureService extends CustomService {
    private readonly core = inject(ConsultorioCompartilhamentoService);

    buscar(params: Pessoa & { idConsultorio: number }): Observable<ConsultorioCompartilhamentoRequest[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }
}
